import { configureStore } from "@reduxjs/toolkit";
import { adminInmersys } from "./AdminInmersys/adminInmersysSlice";
import { authSlice } from "./auth/authSlice";
import { menuViewSlice } from "./MenuSlice/menuSlice";
import { tableSlice } from "./tableSlice/tableSlice";
import { vrlSlice } from "./VRL/vrlSlice";
import { vrlTraining } from "./VRT/vrtSlice";

export const store = configureStore({
	reducer: {
		auth: authSlice.reducer,
		menuView: menuViewSlice.reducer,
		table: tableSlice.reducer,
		adminInmersys: adminInmersys.reducer,
		vrlSlice: vrlSlice.reducer,
		vrtSlice: vrlTraining.reducer,
	},
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: {
				// Ignore these action types
				ignoredActions: ["table/onSetArrayHeaders"],
				// Ignore these field paths in all actions
				ignoredActionPaths: ["meta.arg", "payload.rende"],
				// Ignore these paths in the state
				ignoredPaths: ["items.dates"],
			},
		}),
});
